// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../../../../shared/src/Store.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_AsyncData = require("relude/src/Relude_AsyncData.bs.js");
var Relude_AsyncResult = require("relude/src/Relude_AsyncResult.bs.js");
var WebStore_Selectors = require("../WebStore_Selectors.bs.js");
var WebStore_ThunkHelpers = require("../WebStore_ThunkHelpers.bs.js");
var WebStore_Types_Action = require("../WebStore_Types_Action.bs.js");
var WebGraphql_CurrentUser = require("../../graphql/WebGraphql_CurrentUser.bs.js");
var WebGraphql_ManageUsers = require("../../graphql/WebGraphql_ManageUsers.bs.js");
var WebTypes_BusinessAdmin = require("../../types/WebTypes_BusinessAdmin.bs.js");
var CommonTypes_Business_Manager = require("../../../../shared/src/types/business/CommonTypes_Business_Manager.bs.js");

var fetchUser = {
  TAG: /* SideEffects */1,
  _0: Curry._3(WebStore_ThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.setUser, Curry._1(WebGraphql_CurrentUser.GetCurrentUser.queryAsyncResult, undefined))
};

var fetchSavedLocationsForCurrentUser = {
  TAG: /* SideEffects */1,
  _0: (function (param, dispatch) {
      return Relude_Option.fold(Relude_IO.pure(undefined), (function (param) {
                    if (typeof param === "number") {
                      return Relude_IO.pure(undefined);
                    } else {
                      return Curry._1(dispatch, WebStore_Types_Action.fetchSavedLocations(param._0.business));
                    }
                  }), Relude_AsyncResult.getOk(param.currentUser));
    })
};

function fetchSavedLocations(business) {
  return {
          TAG: /* SideEffects */1,
          _0: Curry._3(WebStore_ThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.updateSavedLocations, Curry._1(WebGraphql_CurrentUser.GetSavedLocations.queryAsyncResult, business))
        };
}

var fetchSavedBusinessAdmins = {
  TAG: /* SideEffects */1,
  _0: Curry._3(WebStore_ThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.updateSavedBusinessAdmins, Curry._1(WebGraphql_ManageUsers.GetBusinessAdmins.queryAsyncResult, undefined))
};

function addBusinessAdmin(newBusinessAdminInfo) {
  return {
          TAG: /* SideEffects */1,
          _0: (function (state, dispatch) {
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.finishAddEditAdmin, dispatch, param);
                          }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_ManageUsers.AddBusinessAdmin.mutate, newBusinessAdminInfo, WebStore_Selectors.getApolloClient(state))));
            })
        };
}

function editBusinessAdmin(updatedBusinessAdminInfo) {
  return {
          TAG: /* SideEffects */1,
          _0: (function (state, dispatch) {
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.finishAddEditAdmin, dispatch, param);
                          }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_ManageUsers.EditBusinessAdmin.mutate, updatedBusinessAdminInfo, WebStore_Selectors.getApolloClient(state))));
            })
        };
}

function removeBusinessAdmin(adminIdToRemove) {
  return {
          TAG: /* SideEffects */1,
          _0: (function (state, dispatch) {
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.finishRemoveAdmin, dispatch, param);
                          }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_ManageUsers.RemoveBusinessAdmin.mutate, adminIdToRemove, WebStore_Selectors.getApolloClient(state))));
            })
        };
}

var fetchSavedBusinessManagers = {
  TAG: /* SideEffects */1,
  _0: Curry._3(WebStore_ThunkHelpers.loadAsyncData, undefined, WebStore_Types_Action.updateSavedBusinessManagers, Curry._1(WebGraphql_ManageUsers.GetBusinessManagers.queryAsyncResult, undefined))
};

function addBusinessManager(newBusinessManagerInfo) {
  return {
          TAG: /* SideEffects */1,
          _0: (function (state, dispatch) {
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.finishAddEditManager, dispatch, param);
                          }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_ManageUsers.AddBusinessManager.mutate, newBusinessManagerInfo, WebStore_Selectors.getApolloClient(state))));
            })
        };
}

function editBusinessManager(updatedBusinessManagerInfo) {
  return {
          TAG: /* SideEffects */1,
          _0: (function (state, dispatch) {
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.finishAddEditManager, dispatch, param);
                          }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_ManageUsers.EditBusinessManager.mutate, updatedBusinessManagerInfo, WebStore_Selectors.getApolloClient(state))));
            })
        };
}

function removeBusinessManager(managerIdToRemove) {
  return {
          TAG: /* SideEffects */1,
          _0: (function (state, dispatch) {
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.finishRemoveManager, dispatch, param);
                          }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_ManageUsers.RemoveBusinessManager.mutate, managerIdToRemove, WebStore_Selectors.getApolloClient(state))));
            })
        };
}

function addBusinessLocation(newBusinessLocationInfo) {
  return {
          TAG: /* SideEffects */1,
          _0: (function (state, dispatch) {
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.finishAddEditLocation, dispatch, param);
                          }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_ManageUsers.AddBusinessLocation.mutate, newBusinessLocationInfo, WebStore_Selectors.getApolloClient(state))));
            })
        };
}

function editBusinessLocation(updatedBusinessLocationInfo) {
  return {
          TAG: /* SideEffects */1,
          _0: (function (state, dispatch) {
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.finishAddEditLocation, dispatch, param);
                          }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_ManageUsers.EditBusinessLocation.mutate, updatedBusinessLocationInfo, WebStore_Selectors.getApolloClient(state))));
            })
        };
}

function removeBusinessLocation(locationIdToRemove) {
  return {
          TAG: /* SideEffects */1,
          _0: (function (state, dispatch) {
              return Relude_IO.flatMap((function (param) {
                            return Relude_Globals.$great$great(WebStore_Types_Action.finishRemoveLocation, dispatch, param);
                          }), Curry._2(Relude_IO.mapError, Store.graphQL, Curry._2(WebGraphql_ManageUsers.RemoveBusinessLocation.mutate, locationIdToRemove, WebStore_Selectors.getApolloClient(state))));
            })
        };
}

var SideEffects = {
  fetchUser: fetchUser,
  fetchSavedLocationsForCurrentUser: fetchSavedLocationsForCurrentUser,
  fetchSavedLocations: fetchSavedLocations,
  fetchSavedBusinessAdmins: fetchSavedBusinessAdmins,
  addBusinessAdmin: addBusinessAdmin,
  editBusinessAdmin: editBusinessAdmin,
  removeBusinessAdmin: removeBusinessAdmin,
  fetchSavedBusinessManagers: fetchSavedBusinessManagers,
  addBusinessManager: addBusinessManager,
  editBusinessManager: editBusinessManager,
  removeBusinessManager: removeBusinessManager,
  addBusinessLocation: addBusinessLocation,
  editBusinessLocation: editBusinessLocation,
  removeBusinessLocation: removeBusinessLocation
};

function updateSavedBusinessAdmins(state, savedBusinessAdmins) {
  return Curry._4(WebStore_ThunkHelpers.updateAsyncResult, (function (param) {
                return param.savedBusinessAdmins;
              }), (function (state, savedBusinessAdmins) {
                return {
                        cities: state.cities,
                        currentUser: state.currentUser,
                        dashboard: state.dashboard,
                        editingShift: state.editingShift,
                        layout: state.layout,
                        postAShift: state.postAShift,
                        savedBusinessAdmins: savedBusinessAdmins,
                        savedBusinessManagers: state.savedBusinessManagers,
                        savedLocations: state.savedLocations,
                        token: state.token,
                        timing: state.timing,
                        view: state.view
                      };
              }), state, savedBusinessAdmins);
}

function finishAddEditAdmin(state, newAdmin) {
  var currentView = state.view;
  var savedBusinessAdmins = state.savedBusinessAdmins;
  return Relude_Option.fold(Store.noUpdate, (function (newAdmin) {
                var partial_arg = {
                  TAG: /* BusinessDashboard */0,
                  _0: {
                    TAG: /* Settings */0,
                    _0: {
                      TAG: /* Admins */0,
                      _0: /* Viewing */0
                    }
                  }
                };
                return {
                        TAG: /* Update */0,
                        _0: {
                          cities: state.cities,
                          currentUser: state.currentUser,
                          dashboard: state.dashboard,
                          editingShift: state.editingShift,
                          layout: state.layout,
                          postAShift: state.postAShift,
                          savedBusinessAdmins: Relude_Option.fold(savedBusinessAdmins, Relude_AsyncResult.completeOk, Relude_Option.orElse(Relude_Option.pure(Curry._1(WebTypes_BusinessAdmin.$$Set.fromArray, Relude_Option.fold([], Relude_Array.pure, newAdmin))), Curry._2(Relude_Option.mapTuple2, (function (newAdmin, savedBusinessAdmins) {
                                          return Curry._2(WebTypes_BusinessAdmin.$$Set.add, newAdmin, Curry._2(WebTypes_BusinessAdmin.$$Set.remove, newAdmin, savedBusinessAdmins));
                                        }), [
                                        newAdmin,
                                        Relude_AsyncResult.getOk(savedBusinessAdmins)
                                      ]))),
                          savedBusinessManagers: state.savedBusinessManagers,
                          savedLocations: state.savedLocations,
                          token: state.token,
                          timing: state.timing,
                          view: Relude_Option.fold(currentView, (function (param) {
                                  return Relude_Globals.$$const(partial_arg, param);
                                }), Relude_Option.map((function (prim) {
                                      
                                    }), Relude_AsyncResult.getOk(savedBusinessAdmins)))
                        }
                      };
              }), Relude_Option.pure(Relude_AsyncData.getComplete(newAdmin)));
}

function finishRemoveAdmin(state, removedAdmin) {
  var currentView = state.view;
  var savedBusinessAdmins = state.savedBusinessAdmins;
  return Relude_Option.fold(Store.noUpdate, (function (removedAdmin) {
                var partial_arg = {
                  TAG: /* BusinessDashboard */0,
                  _0: {
                    TAG: /* Settings */0,
                    _0: {
                      TAG: /* Admins */0,
                      _0: /* Viewing */0
                    }
                  }
                };
                return {
                        TAG: /* Update */0,
                        _0: {
                          cities: state.cities,
                          currentUser: state.currentUser,
                          dashboard: state.dashboard,
                          editingShift: state.editingShift,
                          layout: state.layout,
                          postAShift: state.postAShift,
                          savedBusinessAdmins: Relude_Option.fold(savedBusinessAdmins, Relude_AsyncResult.completeOk, Curry._2(Relude_Option.mapTuple2, (function (removedAdmin, savedBusinessAdmins) {
                                      return Curry._2(WebTypes_BusinessAdmin.$$Set.remove, removedAdmin, savedBusinessAdmins);
                                    }), [
                                    removedAdmin,
                                    Relude_AsyncResult.getOk(savedBusinessAdmins)
                                  ])),
                          savedBusinessManagers: state.savedBusinessManagers,
                          savedLocations: state.savedLocations,
                          token: state.token,
                          timing: state.timing,
                          view: Relude_Option.fold(currentView, (function (param) {
                                  return Relude_Globals.$$const(partial_arg, param);
                                }), Relude_Option.map((function (prim) {
                                      
                                    }), Relude_AsyncResult.getOk(savedBusinessAdmins)))
                        }
                      };
              }), Relude_Option.pure(Relude_AsyncData.getComplete(removedAdmin)));
}

function updateSavedBusinessManagers(state, savedBusinessManagers) {
  return Curry._4(WebStore_ThunkHelpers.updateAsyncResult, (function (param) {
                return param.savedBusinessManagers;
              }), (function (state, savedBusinessManagers) {
                return {
                        cities: state.cities,
                        currentUser: state.currentUser,
                        dashboard: state.dashboard,
                        editingShift: state.editingShift,
                        layout: state.layout,
                        postAShift: state.postAShift,
                        savedBusinessAdmins: state.savedBusinessAdmins,
                        savedBusinessManagers: savedBusinessManagers,
                        savedLocations: state.savedLocations,
                        token: state.token,
                        timing: state.timing,
                        view: state.view
                      };
              }), state, savedBusinessManagers);
}

function finishAddEditManager(state, newManager) {
  var currentView = state.view;
  var savedBusinessManagers = state.savedBusinessManagers;
  return Relude_Option.fold(Store.noUpdate, (function (newManager) {
                var partial_arg = {
                  TAG: /* BusinessDashboard */0,
                  _0: {
                    TAG: /* Settings */0,
                    _0: {
                      TAG: /* Managers */1,
                      _0: /* Viewing */0
                    }
                  }
                };
                return {
                        TAG: /* Update */0,
                        _0: {
                          cities: state.cities,
                          currentUser: state.currentUser,
                          dashboard: state.dashboard,
                          editingShift: state.editingShift,
                          layout: state.layout,
                          postAShift: state.postAShift,
                          savedBusinessAdmins: state.savedBusinessAdmins,
                          savedBusinessManagers: Relude_Option.fold(savedBusinessManagers, Relude_AsyncResult.completeOk, Relude_Option.orElse(Relude_Option.pure(Curry._1(CommonTypes_Business_Manager.$$Set.fromArray, Relude_Option.fold([], Relude_Array.pure, newManager))), Curry._2(Relude_Option.mapTuple2, (function (newManager, savedBusinessManagers) {
                                          return Curry._2(CommonTypes_Business_Manager.$$Set.add, newManager, Curry._2(CommonTypes_Business_Manager.$$Set.remove, newManager, savedBusinessManagers));
                                        }), [
                                        newManager,
                                        Relude_AsyncResult.getOk(savedBusinessManagers)
                                      ]))),
                          savedLocations: state.savedLocations,
                          token: state.token,
                          timing: state.timing,
                          view: Relude_Option.fold(currentView, (function (param) {
                                  return Relude_Globals.$$const(partial_arg, param);
                                }), Relude_Option.map((function (prim) {
                                      
                                    }), Relude_AsyncResult.getOk(savedBusinessManagers)))
                        }
                      };
              }), Relude_Option.pure(Relude_AsyncData.getComplete(newManager)));
}

function finishRemoveManager(state, removedManager) {
  var currentView = state.view;
  var savedBusinessManagers = state.savedBusinessManagers;
  return Relude_Option.fold(Store.noUpdate, (function (removedManager) {
                var partial_arg = {
                  TAG: /* BusinessDashboard */0,
                  _0: {
                    TAG: /* Settings */0,
                    _0: {
                      TAG: /* Managers */1,
                      _0: /* Viewing */0
                    }
                  }
                };
                return {
                        TAG: /* Update */0,
                        _0: {
                          cities: state.cities,
                          currentUser: state.currentUser,
                          dashboard: state.dashboard,
                          editingShift: state.editingShift,
                          layout: state.layout,
                          postAShift: state.postAShift,
                          savedBusinessAdmins: state.savedBusinessAdmins,
                          savedBusinessManagers: Relude_Option.fold(savedBusinessManagers, Relude_AsyncResult.completeOk, Curry._2(Relude_Option.mapTuple2, (function (removedManager, savedBusinessManagers) {
                                      return Curry._2(CommonTypes_Business_Manager.$$Set.remove, removedManager, savedBusinessManagers);
                                    }), [
                                    removedManager,
                                    Relude_AsyncResult.getOk(savedBusinessManagers)
                                  ])),
                          savedLocations: state.savedLocations,
                          token: state.token,
                          timing: state.timing,
                          view: Relude_Option.fold(currentView, (function (param) {
                                  return Relude_Globals.$$const(partial_arg, param);
                                }), Relude_Option.map((function (prim) {
                                      
                                    }), Relude_AsyncResult.getOk(savedBusinessManagers)))
                        }
                      };
              }), Relude_Option.pure(Relude_AsyncData.getComplete(removedManager)));
}

function finishAddEditLocation(state, newLocation) {
  var currentView = state.view;
  var savedLocations = state.savedLocations;
  return Relude_Option.fold(Store.noUpdate, (function (newLocation) {
                var partial_arg = {
                  TAG: /* BusinessDashboard */0,
                  _0: {
                    TAG: /* Settings */0,
                    _0: {
                      TAG: /* Locations */2,
                      _0: /* Viewing */0
                    }
                  }
                };
                return {
                        TAG: /* Update */0,
                        _0: {
                          cities: state.cities,
                          currentUser: state.currentUser,
                          dashboard: state.dashboard,
                          editingShift: state.editingShift,
                          layout: state.layout,
                          postAShift: state.postAShift,
                          savedBusinessAdmins: state.savedBusinessAdmins,
                          savedBusinessManagers: state.savedBusinessManagers,
                          savedLocations: Relude_AsyncResult.map((function (param) {
                                  return Relude_Set.add(newLocation, param);
                                }), savedLocations),
                          token: state.token,
                          timing: state.timing,
                          view: Relude_Option.fold(currentView, (function (param) {
                                  return Relude_Globals.$$const(partial_arg, param);
                                }), Relude_Option.map((function (prim) {
                                      
                                    }), Relude_AsyncResult.getOk(savedLocations)))
                        }
                      };
              }), Relude_AsyncData.getComplete(newLocation));
}

function finishRemoveLocation(state, removedLocation) {
  var savedLocations = state.savedLocations;
  return Relude_Option.fold(Store.noUpdate, (function (removedLocation) {
                return {
                        TAG: /* Update */0,
                        _0: {
                          cities: state.cities,
                          currentUser: state.currentUser,
                          dashboard: state.dashboard,
                          editingShift: state.editingShift,
                          layout: state.layout,
                          postAShift: state.postAShift,
                          savedBusinessAdmins: state.savedBusinessAdmins,
                          savedBusinessManagers: state.savedBusinessManagers,
                          savedLocations: Relude_AsyncResult.map((function (param) {
                                  return Relude_Set.remove(removedLocation, param);
                                }), savedLocations),
                          token: state.token,
                          timing: state.timing,
                          view: {
                            TAG: /* BusinessDashboard */0,
                            _0: {
                              TAG: /* Settings */0,
                              _0: {
                                TAG: /* Locations */2,
                                _0: /* Viewing */0
                              }
                            }
                          }
                        }
                      };
              }), Relude_AsyncData.getComplete(removedLocation));
}

var Pure = {
  updateSavedBusinessAdmins: updateSavedBusinessAdmins,
  finishAddEditAdmin: finishAddEditAdmin,
  finishRemoveAdmin: finishRemoveAdmin,
  updateSavedBusinessManagers: updateSavedBusinessManagers,
  finishAddEditManager: finishAddEditManager,
  finishRemoveManager: finishRemoveManager,
  finishAddEditLocation: finishAddEditLocation,
  finishRemoveLocation: finishRemoveLocation
};

exports.SideEffects = SideEffects;
exports.Pure = Pure;
/* fetchUser Not a pure module */
